import { Transaction as TransactionCardHOC } from "./TransactionContext";
import { TransactionHeader } from "./TransactionHeader";
import { TransactionSign } from "./TransactionSign";

export { TransactionHeader } from "./TransactionHeader";
export { TransactionSign } from "./TransactionSign";
export { TransactionInfo } from "./TransactionInfo";

export const TransactionCard = Object.assign(TransactionCardHOC, {
    Header: TransactionHeader,
    Sign: TransactionSign,
});

export default TransactionCard;
